import {useState, useEffect} from "react";
import fb from "../firebase";
import {ProprietarioObject} from "models/Proprietario";
import {useFirestore, UseFirestoreOptions} from "./useFirestore";


export const useGetProprietario = (proprietarioId?: string): [ProprietarioObject|undefined, boolean, boolean] => {
  const [isLoading, setIsLoading] = useState(false);
  const [proprietario, setProprietario] = useState<ProprietarioObject>();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (proprietarioId) {
      // console.log(`useGetProprietario listener for: ${proprietarioId}`);
      setIsLoading(true);
      const query = fb.db.collection('proprietarios').doc(proprietarioId);

      const _cancelListener = query.onSnapshot(snap => {
        setIsLoading(false);
        setNotFound(!snap.exists);
        if (snap.exists)
          setProprietario(fb.doc(snap));
        else
          setProprietario(undefined);

        // console.log('useGetProprietario SNAP', {proprietarioId, snap});
      });

      return () => {
        // console.log(`useGetProprietario listener for: ${proprietarioId} CANCELLED`);
        _cancelListener();
      }
    }
  }, [proprietarioId]);

  return [proprietario, isLoading, notFound];
}
export const useProprietarios = (options: UseFirestoreOptions): [ProprietarioObject[], boolean] => {

  return useFirestore({
    queryKey: 'useProprietarios',
    query: () => fb.db.collection('proprietarios')
      .orderBy('nome', 'asc'),
    options,
  });
}

export const useProprietariosUser = (args: {userId: string}, options?: UseFirestoreOptions): [ProprietarioObject[], boolean] => {
  const {userId} = args;

  return useFirestore<ProprietarioObject>({
    queryKey: `useProprietariosUser:${userId}`,
    query: () => fb.db.collection('proprietarios')
      .where('_users', 'array-contains', userId)
      .orderBy('nome', 'asc'),
    options,
  });
}